import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ChangeEventListener, Selectable, SelectEventListener } from '@philips-emr/tws-core/lib/component/types';
import { Value } from '@philips-emr/tws-core/src/types';

export interface AttachmentsListItem {
  label: string;
  value: string;
}

class AttachmentsListAPI extends ComponentAPI<{ data: AttachmentsListItem[] }> implements Selectable<AttachmentsListItem> {
  /** @event */
  @AwesomeEvent
  onSelect = new SelectEventListener<AttachmentsListItem>();

  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, Value>>();

  setData(data: AttachmentsListItem[]): void {
    this.setState({ data });
  }

  pushData(itemList: AttachmentsListItem) : void{
    const oldData = this.getData();
    if (oldData) {
      oldData.push(itemList);
      const data = oldData;
      this.setState({ data });
    } else {
      const data = [itemList];
      this.setState({ data });

    }

  }

  getData(): AttachmentsListItem[] {
    return this.state.data;
  }
}

export default AttachmentsListAPI;
